import { ToastOptions } from "react-toastify";

export const toastOptionsTopRight: ToastOptions = {
    position: 'top-right',
    autoClose: 10000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};
